import { render } from "./ChatBotFunctions.vue?vue&type=template&id=39445978"
import script from "./ChatBotFunctions.vue?vue&type=script&lang=js"
export * from "./ChatBotFunctions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__